module.exports = __webpack_public_path__ + "img/dealboard-square-white.bbce2614.svg";